import React from "react";
import { MenuItem } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import { UI_ICONS } from "../../layout/menuIcons";
import { useMutes } from "../../context/Mutes/MutesContext";

// Item de menu: "Reativar som" (direto) quando silenciada, senão abre o diálogo via onMute.
const MuteMenuItem = ({ contactId, onMute, onDone, className, iconClassName }) => {
  const { isMuted, unmute } = useMutes();
  const muted = isMuted(contactId);
  const Icon = UI_ICONS.muted;

  const handleClick = async () => {
    if (!muted) {
      onMute();
      return;
    }
    try {
      await unmute(contactId);
    } catch (err) {
      toastError(err);
    }
    if (onDone) onDone();
  };

  return (
    <MenuItem className={className} style={{ gap: 10 }} onClick={handleClick}>
      <Icon className={iconClassName} style={{ fontSize: 18, flexShrink: 0 }} />
      {muted ? i18n.t("mutes.menuUnmute") : i18n.t("mutes.menuMute")}
    </MenuItem>
  );
};

export default MuteMenuItem;
